import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="terms-container">
      <h1>Privacy Policy</h1>

      <p>
        Transcare Agencies respects your privacy and is committed to
        protecting your personal information.
      </p>

      <h3>Information We Collect</h3>
      <p>
        We may collect personal information such as name, email address,
        phone number, and information submitted through contact forms.
      </p>

      <h3>How We Use Your Information</h3>
      <p>
        The information we collect helps us respond to inquiries, provide
        services, and improve our website experience.
      </p>

      <h3>Data Protection</h3>
      <p>
        We take reasonable measures to protect user data from unauthorized
        access or disclosure.
      </p>

      <h3>Policy Updates</h3>
      <p>
        We may update this Privacy Policy occasionally. Changes will be
        posted on this page.
      </p>
    </div>
  );
};

export default PrivacyPolicy;